<nb-card class="customCardBorder" style="height: 100%;">
  <nb-card-header>
    <div class="row">
      <div class="col-lg-6 col-12">
        <h3>Estimate Locks</h3>
      </div>
      <div class="col-lg-6 col-12 alignRight">

      </div>
    </div>
  </nb-card-header>
  <nb-card-body [nbSpinner]="this.isLoading">
    <div class="mat-elevation-z1">
      <div style="overflow-x: auto; margin-top: 20px;">
        <table mat-table class="full-width-table" [dataSource]="dataSource" matSort aria-label="Elements">
          <!-- Id Column -->
          <ng-container matColumnDef="id">
            <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
            <td mat-cell *matCellDef="let row">{{row.id}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row">{{row.estimateType != null ? row.estimateType.name : "Final"}}</td>
          </ng-container>

          <ng-container matColumnDef="cropYear">
            <th class="tableHeader" mat-header-cell *matHeaderCellDef mat-sort-header>Crop Year</th>
            <td mat-cell *matCellDef="let row">{{row.cropYear.name}}</td>
          </ng-container>

          <ng-container matColumnDef="isActive">
            <th mat-header-cell class="tableHeader" *matHeaderCellDef mat-sort-header>Is Active</th>
            <td mat-cell *matCellDef="let row">
              <button mat-icon-button (click)="toggleActive(row);">
              <div *ngIf="row.isActive === true" style="color: green;">
                <fa-icon [icon]="faCheck"></fa-icon>
              </div>
              <div *ngIf="row.isActive === false" style="color: darkRed">
                <fa-icon [icon]="faTimes"></fa-icon>
              </div>
            </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="50"
        [pageSizeOptions]="[25, 50, 100, 250]">
      </mat-paginator>
    </div>
  </nb-card-body>
</nb-card>